import { ANIMATE_TOOL } from "../../../../../../../../routes.ts";
import { animateSettingsStorage } from "../../../../../../../boardState/stores/settings/animateSettingsStorage.ts";

export const useAnimateSettings = (boardUuid: string) => {
  const settings = animateSettingsStorage.useSettings(boardUuid);

  const setSettings = animateSettingsStorage.useSetSettings(boardUuid);

  return {
    tool: ANIMATE_TOOL,
    settings,
    setSettings,
    modelActions: undefined,
  };
};
